import React, { Component } from 'react';
import { Switch, Route, Redirect, withRouter, BrowserRouter as Router } from "react-router-dom";
import { connect } from 'react-redux';
import { createHashHistory } from 'history';
import HomeRoute from "../../Home/Routes/HomeRoute";
import ChatRoute from '../Modules/ChatHistory/Routes/ChatRoute';
import TemplateRoute from '../Modules/Template/Routes/TemplateRoute';
import ContactManagementRoute from '../../ContactManagement/Routes/ContactManagementRoute';
import AccountRoute from '../../Account/Routes/AccountRoute';
class index extends Component {
  componentDidMount() {
    if (this.props.token && this.props.token != "") {
      if (this.props.history.location.pathname.split('/')[2] == "login") {
        this.props.history.push(`/${localStorage.getItem('i18nextLng')}/home`);
      }
    }
  }
  render() {

    return (
      <>
        <Switch>
          <Route exact path="/" component={HomeRoute} />
          <Route exact path="/:lng/home" component={HomeRoute} />
          <Route exact path="/:lng/chat" component={ChatRoute} />
          <Route exact path="/:lng/template" component={TemplateRoute} />
          <Route exact path="/:lng/contact_management" component={ContactManagementRoute} />
          <Route exact path="/:lng/account" component={AccountRoute} />
        </Switch>

      </>
    );
  }
}

const mapStateToProps = (globalState) => {
  return {
    userCredentials: globalState.LoginReducer.userCredentials,
    accessToken: globalState.LoginReducer.accessToken,
    token: globalState.LoginReducer.token,
    leftbar: globalState.mainReducerData.leftbar,
  };
}

export default connect(mapStateToProps)(withRouter(index));
// export default index;
